// extracted by mini-css-extract-plugin
module.exports =  {"container":"_25d45facb5--container--PXAP9","close-icon":"_25d45facb5--close-icon--f2Je1","text":"_25d45facb5--text--BXOyE","buttons":"_25d45facb5--buttons--wFVrE"};